import { ExternalLink, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Hint } from '@/components/Hint';
import type { RunRequest } from '@/api/runRequests';
import { isOpen } from './runState';

/** Where the sessions live: claude-manager, behind the usual sign-in. */
const CLAUDE_MANAGER_URL = 'https://code.kent.pw';

/**
 * An attended Claude session's button: "Open Claude session" (its chat pane,
 * claude-manager's `?chat=<run session id>`) once claimed, "Starting session…"
 * while queued, else the caller's own start button.
 */
export function SessionButton({ request, size = 'sm', children }: {
  request: RunRequest | null;
  size?: 'sm' | 'default';
  /** The start button, shown while no session is open. */
  children: React.ReactNode;
}) {
  const cls = size === 'sm' ? 'h-8 gap-1.5 px-3 text-xs' : undefined;
  if (!request || !isOpen(request)) return <>{children}</>;
  if (request.claimedAt) {
    const href = request.runSessionId
      ? `${CLAUDE_MANAGER_URL}/?chat=${encodeURIComponent(request.runSessionId)}`
      : CLAUDE_MANAGER_URL;
    return (
      <Button variant="outline" size={size} className={cls} asChild>
        <a href={href} target="claude-manager" rel="noreferrer"><ExternalLink />Open Claude session</a>
      </Button>
    );
  }
  return (
    <Hint content="Opens in claude-manager as soon as the Mac is awake.">
      <span><Button variant="outline" size={size} className={cls} disabled>
        <Loader2 className="animate-spin" />Starting session…
      </Button></span>
    </Hint>
  );
}
